import styled from "@emotion/styled";
import { Link } from "gatsby";
import theme from "../../styles/theme"

// Reusable Gatsby Link component with similar
// loft styles as Loft Link Component
export default styled(Link)`
    font-weight: 600;
    text-decoration: none;
    color: ${theme.colors.blues[100]};

    &:hover {
        color: ${theme.colors.blues[125]};
        text-decoration: underline;
    }

    &:active {
        color: ${theme.colors.blues[125]};
    }
`